import React from 'react';
import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import './index.less';
import './index.en.less';
import Section0 from './section0';
interface IWelcomeTopicProps {
  settings: any;
}

const WelcomeTopic: React.FunctionComponent<IWelcomeTopicProps> = ({
  settings,
}) => (
  <TopicContainer className="start">
    <TopicItem className="start-bg" id="1">
      <Section0 settings={settings} />
    </TopicItem>
  </TopicContainer>
);

export default WelcomeTopic;
